export default "__VITE_ASSET__a975ea4f__"